import { messages } from '@asuene-esg/i18n/src/locales/messages'

import { setInitialLocale } from './utils/i18n'

export default defineI18nConfig(() => {
  return {
    legacy: false,
    lazy: true,
    locale: setInitialLocale(),
    availableLocales: Object.keys(messages),
    messages,
    fallbackLocale: 'en',
  }
})
